import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import Avatar from '../../../Avatar'
import { getAssetLink } from '../../../helpers/get-asset-link'
import { cancelAmenityReservation } from '../../../reducers/Organisation/reservationsReducer'
import ConfirmPopup from '../../Popups/ConfirmPopup'
import DoubleOptionPopup from '../../Popups/DoubleOptionPopup'

const SingleReservationDetails = ({
  reservation: reservationObject,
  cancelAmenityReservation,
  refetch,
  isMultiDay,
}) => {
  const { t } = useTranslation(['reservations', 'common'])
  const [cancelFreePopup, setCancelFreePopup] = useState(false)
  const [cancelPaidPopup, setCancelPaidPopup] = useState(false)

  const reservation = isMultiDay
    ? reservationObject
    : reservationObject.reservations && reservationObject.reservations[0]
  const openConfirmationPopup = () => {
    if (reservation.chargeAmount === 0) {
      setCancelFreePopup(true)
    } else {
      setCancelPaidPopup(true)
    }
  }

  const cancelReservationById = async (refund) => {
    try {
      await cancelAmenityReservation(reservation.id, refund)
      setCancelFreePopup(false)
      await refetch()
    } catch (err) {
      console.error(err)
    }
  }
  const selectedReservationData = reservation && (reservation.client || reservation.guest)
  if (!selectedReservationData) return null
  return (
    <div className={'reservation-details-container'}>
      <div className={'request-details'}>
        <div className={'request-details__head'} />
        <div className={'request-details__avatar'}>
          <Avatar
            size="big"
            style={{ width: '74px', height: '74px' }}
            square
            zoomTitle={`${selectedReservationData.firstName} ${selectedReservationData.lastName}`}
            zoomable
          >
            {selectedReservationData.avatar ? (
              <img
                src={getAssetLink({
                  path: 'chitown-avatar/avatar',
                  file: selectedReservationData.avatar,
                })}
                alt=""
              />
            ) : (
              <img />
            )}
          </Avatar>
          <div className={'request-details__avatar-text'}>
            <strong>{`${selectedReservationData.firstName} ${selectedReservationData.lastName}`}</strong>
            <p className={'request-details__avatar-text-sub'}>
              {selectedReservationData.unit
                ? t('reservations:singleReservationDetails.unitPrefix', {
                    unit: selectedReservationData.unit,
                  })
                : ''}
            </p>
          </div>
        </div>
        <div className={'request-details__personal-info'}>
          <div className={'request-details__personal-info-item'}>
            <strong>{t('reservations:singleReservationDetails.phone')}</strong>
            <p>{selectedReservationData.phone || '—'}</p>
          </div>

          <div className={'request-details__personal-info-item'}>
            <strong>{t('reservations:singleReservationDetails.email')}</strong>
            <p>{(selectedReservationData && selectedReservationData.email) || '—'}</p>
          </div>
        </div>

        <div className={'request-details__personal-info'}>
          <div className={'request-details__personal-info-item'}>
            <strong>{t('reservations:singleReservationDetails.price')}</strong>
            <p>{reservation.chargeAmount || '0'}</p>
          </div>

          <div className={'request-details__personal-info-item'}>
            <strong>{t('reservations:singleReservationDetails.cancelledBy')}</strong>
            <p>{reservation.cancelledBy || '—'}</p>
          </div>
        </div>

        <div className={'request-details__personal-info'}>
          <div className={'request-details__personal-info-item'}>
            <strong>{t('reservations:singleReservationDetails.refunded')}</strong>
            <p>
              {reservation.refunded ? t('reservations:details.yes') : t('reservations:details.no')}
            </p>
          </div>

          <div className={'request-details__personal-info-item'}>
            {!reservation.refunded && !reservation.cancelled && (
              <button
                className={'button button-primary is-block'}
                onClick={() => openConfirmationPopup()}
              >
                {t('common:actions.cancel')}
              </button>
            )}
          </div>
        </div>
      </div>
      <ConfirmPopup
        title={t('reservations:singleReservationDetails.confirmCancelTitle')}
        isOpen={cancelFreePopup}
        cancelText={t('common:actions.cancel')}
        confirmText={t('common:actions.confirm')}
        cancelCallback={() => setCancelFreePopup(false)}
        confirmCallback={() => {
          cancelReservationById(false)
          setCancelFreePopup(false)
        }}
      />

      <DoubleOptionPopup
        title={t('reservations:singleReservationDetails.confirmCancelTitle')}
        isOpen={cancelPaidPopup}
        cancelText={t('common:actions.cancel')}
        confirmTextFirst={t('reservations:singleReservationDetails.cancelWithRefund')}
        confirmTextSecond={t('reservations:singleReservationDetails.cancelWithoutRefund')}
        cancelCallback={() => setCancelPaidPopup(false)}
        confirmFirstOptionCallback={() => {
          cancelReservationById(true)
          setCancelPaidPopup(false)
        }}
        confirmSecondOptionCallback={() => {
          cancelReservationById(false)
          setCancelPaidPopup(false)
        }}
      />
    </div>
  )
}

export default connect(() => ({}), {
  cancelAmenityReservation,
})(SingleReservationDetails)
